<div class="alert alert-warning">
  <p>
    {{ "This page or operation is not available at the moment, because AstroBin is in READ ONLY mode." | translate }}
  </p>

  <p>
    {{ "For more information, please check out our X feed:" | translate }}
    <a href="https://www.x.com/AstroBin_com" target="_blank">https://www.x.com/AstroBin_com</a>
  </p>
</div>
